// Strings for S2. Only the S2 worker edits this file (see web/README.md).
// Copy from prototype/index.html and assets/app.js; DRAFT = no source there (w2-03 report).
export default {
  title: 'When was the flight?',
  sub: 'The day it was scheduled to leave {city}.',
  subNoCity: 'The day it was scheduled to leave.',
  label: 'Scheduled departure date',
  placeholder: 'dd/mm/yyyy',
  openCalendar: 'Open calendar',
  yesterday: 'Yesterday',
  today: 'Today',
  twoDaysAgo: '2 days ago',
  'cal.prev': 'Previous month',
  'cal.next': 'Next month',
  beyondHorizon:
    "That's outside the window our flight data covers — you can still claim, we'll just ask you for the flight number and what happened.",
} as const;
